@if (loading()) {
  <span class="ui-preloader-button" [matTooltip]="resolvedTooltip()">
    <ui-preloader [color]="PreloaderColor.gray" [diameter]="16"></ui-preloader>
  </span>
} @else {
  <span
    class="ui-icon-reset ui-icon-button"
    [class.disabled]="disabled()"
    [matTooltip]="resolvedTooltip()"
    (click)="onClick()">
  </span>
}
